import * as React from "react";

import { workspaceRouter } from "@v2/trpc/routes/workspace";
import { Navigate } from "react-router-dom";

export const WorkspaceBillingRedirectRoute: React.FC = () => {
  const { data: workspaceId, isLoading } =
    workspaceRouter.getUserDefaultWorkspaceId.useQuery();

  if (isLoading) {
    return null;
  }
  return (
    <Navigate
      to={workspaceId ? `/workspace/${workspaceId}/billing` : "/home"}
    />
  );
};
